"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MapIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function MapIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M23.5879 22H0.412109L2.34668 11H5.53461C5.89936 11.7054 6.32679 12.3759 6.77912 13H4.02637L2.79492 20H21.2051L19.9736 13H17.2209C17.6732 12.3759 18.1006 11.7054 18.4654 11H21.6533L23.5879 22ZM12.6504 15.7593C13.2041 15.2851 18.0557 11.0122 18.0557 7.05566C18.0557 3.71679 15.3389 1 12 1C8.66114 1 5.94434 3.71679 5.94434 7.05565C5.94434 11.0122 10.7959 15.2851 11.3496 15.7593L12 16.3169L12.6504 15.7593V15.7593ZM16.0557 7.05566C16.0557 9.27539 13.5361 12.167 12 13.645C10.4639 12.167 7.94434 9.27539 7.94434 7.05566C7.94434 4.81933 9.76368 3 12 3C14.2363 3 16.0557 4.81934 16.0557 7.05566ZM12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5Z",
    fill: "currentColor"
  }));
}